import Message from '../common/message';
import { ErrorInfo, errorCodes } from '../../utils/error-codes';
import { useTranslation } from 'react-i18next';
import { getErrorKeys } from 'utils';

interface MessageErrorProps {
  errorInfo?: ErrorInfo | null;
  onClose?: () => void;
}

const MessageError = ({ errorInfo, onClose }: MessageErrorProps) => {
  const { t } = useTranslation();
  const { type, titleKey, messageKey } = getErrorKeys(errorInfo);
  return <Message type={type} title={titleKey && t(titleKey)} body={messageKey && t(messageKey)} onClose={onClose} />;
};

export default MessageError;
